/*
  Quiz de iluminación iLumileds
  Usado por: sections/quiz-iluminacion.liquid
  Datos:     templates/collection.quiz-data.liquid (?view=quiz-data)

  El flujo (cuartos → tipos de luz → palabras clave) vive en QUIZ más abajo.
  Las palabras clave se buscan en las etiquetas + título del producto,
  sin acentos ni mayúsculas.
*/
(function (root) {
  'use strict';

  /* ── Flujo del quiz ─────────────────────────────────────────────── */

  // Tipos de luz reutilizables. any: debe tener al menos una; also: además al menos una; none: no debe tener ninguna.
  var FIXTURES = {
    colgante:     { label: 'Colgante', photo: ['suspender', 'colgante'], any: ['suspender', 'supender', 'colgante', 'pendant'], none: ['kit de suspencion', 'cable de suspension', 'magnetico', 'nano track', '48vcc'] },
    colgante_isla:{ label: 'Colgantes sobre isla o barra', photo: ['suspender', 'colgante'], any: ['suspender', 'supender', 'colgante'], none: ['kit de suspencion', 'magnetico', 'nano track', '48vcc'] },
    colgante_mesa:{ label: 'Colgante sobre la mesa', photo: ['suspender', 'colgante'], any: ['suspender', 'supender', 'colgante'], none: ['kit de suspencion', 'magnetico', 'nano track', '48vcc'] },
    lineal_susp:  { label: 'Lineal suspendido', photo: ['lineal'], any: ['suspender-lineal', 'oficinas / escuelas-suspender', 'lineal'], also: ['suspender', 'supender', 'oficinas', 'lineal'], none: ['nano track', 'magnetico', '48vcc'] },
    empotrado:    { label: 'Empotrado en techo', photo: ['empotrar', 'downlight'], any: ['empotrado techo', 'downlight', 'empotrar', 'empotrado'], none: ['piso', 'exterior-empotrar', 'muro-empotrar', 'en muro', 'perfil', 'sobreponer'] },
    sobreponer:   { label: 'Plafón de techo', photo: ['sobreponer'], any: ['sobreponer-circular', 'lamparas-sobreponer', 'decorativas-sobreponer', 'plafon', 'sobreponer-lineales'], none: ['muro', 'perfil', 'exterior'] },
    muro:         { label: 'Luz de muro', photo: ['muro', 'arbotante'], any: ['de muro', 'decorativas-muro', 'decorativo-muro', 'lamparas-de muro', 'arbotante', 'europa-muro-int'], none: ['exterior'] },
    lectura:      { label: 'Lectura junto a la cama', photo: ['lectura', 'muro'], any: ['lectura', 'de muro-cortesia', 'de muro', 'arbotante', 'decorativas-muro'], none: ['exterior'] },
    riel:         { label: 'Spots en riel', photo: ['proyector magnetico', 'riel', 'spot', 'track'], any: ['riel', 'nanotrack', 'microtrack', 'magnetico**magneto', 'track'], none: ['accesorio de riel', 'conector', 'riel de ', 'exterior'] },
    tira:         { label: 'Tira LED indirecta', photo: ['tira led'], any: ['tira led', 'tiras led', 'tira-led', 'kit-tira', 'neon'], none: ['exterior', 'accesorio', 'sin-tira', 'conector', 'fuente', 'driver'] },
    tira_gabinete:{ label: 'Tira LED bajo gabinete', photo: ['tira led'], any: ['tira led', 'tiras led', 'tira-led', 'kit-tira', 'bajo gabinete', 'perfil'], none: ['exterior', 'accesorio', 'sin-tira', 'conector', 'fuente', 'driver'] },
    bano_techo:   { label: 'Empotrado para baño', photo: ['downlight', 'empotrar'], any: ['empotrado techo', 'downlight', 'empotrar', 'sobreponer'], also: ['humedo', 'ip65', 'ip44', 'ip54', 'ip66', 'ip67', 'proteccion'], none: ['piso', 'perfil', 'muro', 'wall washer', 'exterior'] },
    bano_espejo:  { label: 'Muro sobre el espejo', photo: ['espejo', 'vanidad', 'muro'], any: ['de muro', 'arbotante', 'decorativas-muro', 'lamparas-de muro', 'espejo'], also: ['humedo', 'ip44', 'ip54', 'ip65', 'proteccion'], none: ['exterior'] },
    fachada:      { label: 'Fachada o muro', photo: ['muro', 'arbotante'], any: ['exterior-muro', 'de muro-exterior', 'fachada', 'exteriores-para muro', 'arbotante exterior', 'wall washer', 'wallwasher'] },
    jardin:       { label: 'Jardín y macetas', photo: ['estaca', 'jardin'], any: ['jardin', 'estaca', 'spike', 'exterior-jardin'] },
    piso_ext:     { label: 'Empotrado en piso', photo: ['piso'], any: ['empotrado piso', 'para piso', 'piso-ext', 'en piso', 'subacuatic'], none: ['bolardo', 'de muro'] },
    postes:       { label: 'Postes y bolardos', photo: ['bolardo', 'poste'], any: ['bolardo', 'poste', 'bolardos/postes'] },
    tira_ext:     { label: 'Tira LED exterior', photo: ['tira led'], any: ['tira led', 'tiras led', 'tira-led', 'neon'], also: ['exterior', 'ip65', 'ip67', 'ip68'], none: ['accesorio', 'conector', 'fuente', 'driver'] },
    reflector:    { label: 'Reflector de área', photo: ['reflector'], any: ['reflector', 'lamparas-reflectores', 'fachadas', 'wall washer', 'wallwasher'], none: ['proyectores spot-mini', 'vitrina', 'magnetico', 'nano track'] },
    vitrina:      { label: 'Exhibición y vitrinas', photo: ['vitrina', 'proyector', 'spot'], any: ['vitrina', 'exhibicion', 'proyectores spot', 'riel', 'nanotrack', 'microtrack'], none: ['accesorio de riel', 'conector', 'exterior'] },
    comercial:    { label: 'Empotrado comercial', photo: ['downlight', 'empotrar'], any: ['empotrado techo', 'downlight', 'empotrar'], also: ['comercial', 'profesional', 'oficinas'], none: ['piso', 'perfil', 'sobreponer', 'en muro'] }
  };

  var ROOMS = [
    { id: 'sala',     label: 'Sala',            icon: 'sofa',    prefer: ['decorativ', 'residencial', 'atenuable'], fixtures: ['colgante', 'empotrado', 'muro', 'riel', 'tira', 'sobreponer'] },
    { id: 'cocina',   label: 'Cocina',          icon: 'kitchen', prefer: ['irc90', 'humedo'], fixtures: ['colgante_isla', 'empotrado', 'tira_gabinete', 'riel'] },
    { id: 'comedor',  label: 'Comedor',         icon: 'dining',  prefer: ['decorativ', 'irc90'], fixtures: ['colgante_mesa', 'empotrado', 'muro', 'riel'] },
    { id: 'recamara', label: 'Recámara',        icon: 'bed',     prefer: ['atenuable', 'residencial', 'decorativ'], fixtures: ['empotrado', 'lectura', 'colgante', 'tira', 'sobreponer'] },
    { id: 'bano',     label: 'Baño',            icon: 'bath',    prefer: ['humedo', 'ip44', 'ip65'], fixtures: ['bano_techo', 'bano_espejo', 'tira'] },
    { id: 'oficina',  label: 'Oficina / Estudio', icon: 'desk',  prefer: ['oficinas', 'profesional', 'deslumbramiento'], fixtures: ['lineal_susp', 'empotrado', 'riel', 'sobreponer'] },
    { id: 'exterior', label: 'Exterior / Jardín', icon: 'tree',  prefer: ['costera', 'ip65', 'ip67'], fixtures: ['fachada', 'jardin', 'piso_ext', 'postes', 'tira_ext'], outdoor: true },
    { id: 'negocio',  label: 'Negocio / Local', icon: 'store',   prefer: ['comercial', 'profesional', 'irc90'], fixtures: ['vitrina', 'comercial', 'colgante', 'reflector'] }
  ];

  var MOODS = [
    { id: 'calida',    label: 'Cálida y acogedora', hint: '2700–3000K', glow: '#ffb45c', any: ['calido', 'calida', '2700k', '3000k', 'neutro calido'] },
    { id: 'natural',   label: 'Natural',            hint: '4000K',      glow: '#fff1d6', any: ['neutro', '4000k', '4100k', '3500k'] },
    { id: 'brillante', label: 'Brillante',          hint: '5000–6500K', glow: '#d8ecff', any: ['frio', 'fria', '5000k', '5700k', '6000k', '6500k', 'blanco dia'] },
    { id: 'ajustable', label: 'Ajustable o de colores', hint: 'CCT · RGB', glow: 'conic', any: ['cct', 'rgb', 'color de luz ajustable', 'tunable', 'colores', 'opciones color', 'opciónes color'] }
  ];

  var BUDGETS = [
    { id: 'b1',  label: 'Hasta $600',       hint: 'Por pieza', min: 0,    max: 600 },
    { id: 'b2',  label: '$600 – $1,500',    hint: 'Por pieza', min: 600,  max: 1500 },
    { id: 'b3',  label: 'Más de $1,500',    hint: 'Por pieza', min: 1500, max: Infinity },
    { id: 'any', label: 'Sin límite',       hint: 'Muéstrame lo mejor', min: 0, max: Infinity }
  ];

  // Tipos de producto que sí son luminarios (el resto: drivers, conectores, cable…).
  var ALLOWED_TYPES = ['luminario', 'tira led interior', 'tira led exterior', 'tira led', 'kit de perfil', 'tubo', 'fibra optica'];
  // Títulos que son accesorios aunque estén dados de alta como Luminario.
  var TITLE_BLOCKLIST = ['filtro', 'kit para', 'kit de ', 'accesorio', 'tapa', 'conector', 'soporte', 'repuesto', 'refaccion', 'difusor', 'mica', 'lente', 'clip', 'grapa', 'cople', 'driver', 'fuente de poder', 'control remoto', 'transformador'];
  var OUTDOOR_ANY = ['exterior', 'ip65', 'ip66', 'ip67', 'ip68', 'proteccion', 'jardin', 'costera', 'sumergible'];

  /* ── Motor ──────────────────────────────────────────────────────── */

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function hasAny(text, words) {
    if (!words || !words.length) return false;
    for (var i = 0; i < words.length; i++) if (text.indexOf(norm(words[i])) !== -1) return true;
    return false;
  }

  function prepare(products, sourceTag) {
    var tag = norm(sourceTag || '');
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var tags = norm((p.tags || []).join('|'));
      var title = norm(p.title);
      if (tag && tags.indexOf(tag) === -1 && title.indexOf(tag) === -1) continue;
      if (ALLOWED_TYPES.indexOf(norm(p.type)) === -1) continue;
      if (!p.image || !p.available) continue;
      if (hasAny(title.slice(0, 40), TITLE_BLOCKLIST)) continue;
      if (hasAny(tags, ['sin imagen'])) continue;
      p._text = tags + '|' + title;
      p._title = title;
      out.push(p);
    }
    return out;
  }

  function matchesFixture(p, fx, room) {
    var t = p._text;
    if (!hasAny(t, fx.any)) return false;
    if (fx.also && !hasAny(t, fx.also)) return false;
    if (fx.none && hasAny(t, fx.none)) return false;
    if (room && room.outdoor && !hasAny(t, OUTDOOR_ANY)) return false;
    return true;
  }

  // Clave de "modelo" para no recomendar 3 variantes del mismo producto.
  // Clave de "modelo" para no recomendar variantes del mismo producto
  // (p. ej. el mismo downlight en 24W, 18W y 12W): se ignoran medidas, potencias y números.
  function modelKey(p) {
    return p._title.replace(/\([^)]*\)/g, ' ').replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(function (w) {
      return w && !/\d/.test(w) && ['luminario', 'lampara', 'de', 'del', 'la', 'el', 'en', 'y', 'o', 'para', 'con', 'tipo', 'ilumileds', 'led', 'luz'].indexOf(w) === -1;
    }).slice(0, 3).join(' ');
  }

  function score(p, mood, budget, room) {
    var s = 0;
    if (room && room.prefer && hasAny(p._text, room.prefer)) s += 1;
    if (mood && hasAny(p._text, mood.any)) s += 3;
    if (budget && budget.id !== 'any') {
      if (p.price >= budget.min && p.price < budget.max) s += 2;
      else s -= Math.min(2, Math.abs((p.price < budget.min ? budget.min - p.price : p.price - budget.max) / Math.max(budget.min, 300)));
    } else {
      s += Math.min(1, p.price / 3000); // sin límite: ligera preferencia por piezas protagonistas
    }
    if (hasAny(p._text, ['mas-vendidos'])) s += 1;
    if (hasAny(p._text, ['irc90'])) s += 0.3;
    if (hasAny(p._text, ['sin-foco'])) s -= 0.5;
    return s;
  }

  function pickTop(list, n, taken) {
    var out = [];
    var seen = {};
    taken = taken || [];
    for (var i = 0; i < taken.length; i++) seen[modelKey(taken[i])] = true;
    for (var j = 0; j < list.length && out.length < n; j++) {
      var k = modelKey(list[j].p);
      if (seen[k]) continue;
      seen[k] = true;
      out.push(list[j].p);
    }
    return out;
  }

  function rank(pool, mood, budget, room) {
    return pool.map(function (p) { return { p: p, s: score(p, mood, budget, room) }; })
      .sort(function (a, b) { return b.s - a.s || a.p.price - b.p.price || (a.p.handle < b.p.handle ? -1 : 1); });
  }

  /**
   * answers: { room, fixture, mood, budget } (ids)
   * Devuelve TODAS las sugerencias en orden (sin repetir modelo): primero las del
   * tipo de luz elegido y después las de los demás tipos del mismo cuarto.
   * El quiz las va mostrando de 3 en 3 ("Muéstrame otras opciones").
   */
  function recommendAll(products, answers) {
    var room = find(ROOMS, answers.room);
    var mood = find(MOODS, answers.mood);
    var budget = find(BUDGETS, answers.budget);
    var fx = FIXTURES[answers.fixture];
    if (!room || !fx) return [];

    var primary = products.filter(function (p) { return matchesFixture(p, fx, room); });
    var picked = pickTop(rank(primary, mood, budget, room), Infinity);

    var others = [];
    room.fixtures.forEach(function (id) {
      if (id === answers.fixture) return;
      products.forEach(function (p) { if (primary.indexOf(p) === -1 && others.indexOf(p) === -1 && matchesFixture(p, FIXTURES[id], room)) others.push(p); });
    });
    return picked.concat(pickTop(rank(others, mood, budget, room), Infinity, picked));
  }

  function recommend(products, answers, n) {
    return recommendAll(products, answers).slice(0, n || 3);
  }

  // Foto representativa para la tarjeta de un tipo de luz (el más vendido de ese tipo).
  function fixtureImage(products, fixtureId, roomId, exclude) {
    var room = find(ROOMS, roomId);
    var fx = FIXTURES[fixtureId];
    if (!fx) return null;
    var best = null, bestS = -Infinity;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (exclude && exclude[p.image]) continue;
      if (!matchesFixture(p, fx, room)) continue;
      // Preferimos productos cuyo título describe el tipo (la etiqueta sola a veces es ambigua).
      var s = (hasAny(p._title, fx.photo || fx.any) ? 3 : 0) + (hasAny(p._text, ['mas-vendidos']) ? 2 : 0) + Math.min(1, p.price / 2000);
      if (s > bestS) { bestS = s; best = p; }
    }
    return best ? best.image : null;
  }

  function find(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }

  var Engine = {
    FIXTURES: FIXTURES, ROOMS: ROOMS, MOODS: MOODS, BUDGETS: BUDGETS,
    norm: norm, prepare: prepare, recommend: recommend, recommendAll: recommendAll, fixtureImage: fixtureImage,
    matchesFixture: matchesFixture, find: find
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = Engine;
  root.MatelecQuizEngine = Engine;
})(typeof window !== 'undefined' ? window : this);

/* ── Interfaz ─────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var E = window.MatelecQuizEngine;
  var CACHE_KEY = 'qz-catalog-v1';
  var CACHE_MIN = 30;

  var ICONS = {
    sofa: '<path d="M9 25v-6a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v6"/><path d="M6 36V27a3 3 0 0 1 6 0v3h24v-3a3 3 0 0 1 6 0v9z"/><path d="M10 36v4M38 36v4"/>',
    kitchen: '<path d="M24 4v7"/><path d="M16 19a8 8 0 0 1 16 0z"/><path d="M21 23h6" opacity=".5"/><path d="M5 31h38"/><path d="M9 31v12M39 31v12M9 37h30"/>',
    dining: '<circle cx="24" cy="26" r="10"/><circle cx="24" cy="26" r="5.5"/><path d="M7 12v8a2.5 2.5 0 0 0 5 0v-8M9.5 22v18"/><path d="M41 12c-3.5 0-5 4.5-5 11h5v17"/>',
    bed: '<path d="M6 12v28"/><path d="M6 31h36v9"/><path d="M42 31v-6a4 4 0 0 0-4-4H21v10"/><circle cx="13.5" cy="25" r="3.5"/>',
    bath: '<path d="M5 24h38v4a10 10 0 0 1-10 10H15A10 10 0 0 1 5 28z"/><path d="M11 24V11a4 4 0 0 1 8 0"/><path d="M14 38l-2 5M34 38l2 5"/>',
    desk: '<path d="M4 28h40M8 28v15M40 28v15"/><path d="M14 28l3-9 9-7"/><path d="M24 9.5l6 5.5-4 3.5-6-5.5z"/><path d="M28 19l3 3" opacity=".5"/>',
    tree: '<path d="M24 44V27"/><path d="M24 31l-5-5M24 35l6-6"/><path d="M24 4c8 0 14 6 14 13 0 6.5-6.5 11-14 11S10 23.5 10 17C10 10 16 4 24 4z"/>',
    store: '<path d="M6 18l4-10h28l4 10"/><path d="M6 18v2a6 6 0 0 0 12 0 6 6 0 0 0 12 0 6 6 0 0 0 12 0v-2z"/><path d="M8 26v17h32V26M20 43V33h8v10"/>'
  };

  var ARROW_L = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var RESTART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v5h5"/></svg>';
  var WA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 3.5A11.8 11.8 0 0 0 1.9 17.7L.3 23.7l6.2-1.6a11.8 11.8 0 0 0 5.6 1.4c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.1-3.4-8.2zM12.1 21.5c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4a9.8 9.8 0 1 1 8.3 4.6zm5.4-7.3c-.3-.1-1.8-.9-2-1s-.5-.1-.7.1-.8 1-.9 1.2-.3.2-.6.1a8 8 0 0 1-2.4-1.5 9 9 0 0 1-1.6-2.1c-.2-.3 0-.5.1-.6l.4-.5.3-.5v-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6a1.1 1.1 0 0 0-.8.4 3.4 3.4 0 0 0-1 2.5 5.9 5.9 0 0 0 1.2 3.1 13.5 13.5 0 0 0 5.2 4.6c.7.3 1.3.5 1.7.6a4.2 4.2 0 0 0 1.9.1 3.1 3.1 0 0 0 2-1.4 2.5 2.5 0 0 0 .2-1.4c-.1-.1-.3-.2-.6-.3z"/></svg>';

  var STEPS = ['room', 'fixture', 'mood', 'budget'];

  function h(tag, attrs, html) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') el.className = attrs[k];
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) el.setAttribute(k, attrs[k]);
    }
    if (html != null) el.innerHTML = html;
    return el;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Los títulos del catálogo son muy largos: nos quedamos con la parte antes de " de iLumileds" / " de línea".
  function shortTitle(t) {
    var s = String(t || '').replace(/\s+(de\s+)?(la\s+)?(l[ií]nea\s+europe[ao]\s+)?(de\s+)?ilumileds.*$/i, '').replace(/\s+de\s+l[ií]nea\s+europe[ao].*$/i, '');
    return s.length > 90 ? s.slice(0, 88).replace(/\s+\S*$/, '') + '…' : s;
  }

  function Quiz(root) {
    this.root = root;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-qz-config]').textContent); } catch (e) {}
    this.cfg = cfg;
    this.state = { step: -1, answers: {}, round: 0, liked: false };
    this.catalog = null;
    this.loading = null;
    this.money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: cfg.currency || 'MXN', maximumFractionDigits: 0 });
    this.build();
    this.load();
    this.render();
  }

  Quiz.prototype.build = function () {
    var self = this;
    this.root.classList.add('qz-ready');
    this.bar = h('div', { class: 'qz-progress', 'aria-hidden': 'true' }, '<span></span>');
    this.back = h('button', { class: 'qz-icon-btn qz-back', type: 'button', 'aria-label': 'Regresar', onclick: function () { self.goBack(); } }, ARROW_L);
    this.counter = h('span', { class: 'qz-counter' });
    this.restartBtn = h('button', { class: 'qz-icon-btn', type: 'button', 'aria-label': 'Volver a empezar', onclick: function () { self.restart(); } }, RESTART);
    this.cartLink = h('a', { class: 'qz-cart', href: (this.cfg.root || '/') + 'cart', hidden: '' });

    var brand = this.cfg.logo
      ? '<img src="' + esc(this.cfg.logo) + '" alt="' + esc(this.cfg.shop || 'Matelec') + '">'
      : '<span class="qz-wordmark">' + esc(this.cfg.shop || 'MATELEC') + '</span>';
    var header = h('header', { class: 'qz-header' });
    var left = h('div', { class: 'qz-header-l' });
    left.appendChild(this.back);
    left.appendChild(h('a', { class: 'qz-brand', href: this.cfg.home || '/' }, brand));
    var right = h('div', { class: 'qz-header-r' });
    right.appendChild(this.counter);
    right.appendChild(this.cartLink);
    right.appendChild(this.restartBtn);
    header.appendChild(left);
    header.appendChild(right);

    this.stage = h('main', { class: 'qz-stage', 'aria-live': 'polite' });
    this.toast = h('div', { class: 'qz-toast', role: 'status', hidden: '' });

    this.root.appendChild(this.bar);
    this.root.appendChild(header);
    this.root.appendChild(this.stage);
    this.root.appendChild(this.toast);
  };

  /* Datos */

  Quiz.prototype.load = function () {
    var self = this;
    var cached = null;
    try {
      cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && (Date.now() - cached.t > CACHE_MIN * 60000 || cached.src !== this.cfg.source)) cached = null;
    } catch (e) { cached = null; }
    if (cached) {
      this.catalog = E.prepare(cached.products, this.cfg.tag);
      return;
    }
    var base = (this.cfg.root || '/') + 'collections/' + (this.cfg.source || 'all') + '?view=quiz-data&page=';
    var getPage = function (n) {
      return fetch(base + n, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
    };
    this.loading = getPage(1).then(function (first) {
      var rest = [];
      for (var n = 2; n <= (first.pages || 1); n++) rest.push(getPage(n));
      return Promise.all(rest).then(function (pages) {
        return pages.reduce(function (all, pg) { return all.concat(pg.products || []); }, first.products || []);
      });
    }).then(function (products) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), src: self.cfg.source, products: products })); } catch (e) {}
      self.catalog = E.prepare(products, self.cfg.tag);
      self.loading = null;
      if (self.state.step === 1 || self.state.step === 4) self.render();
    }).catch(function (err) {
      self.loading = null;
      self.catalog = self.catalog || [];
      self.loadError = err;
      if (self.state.step === 4) self.render();
    });
  };

  /* Navegación */

  Quiz.prototype.select = function (key, value, btn) {
    var self = this;
    this.state.answers[key] = value;
    this.state.round = 0;
    this.state.liked = false;
    if (key === 'room') delete this.state.answers.fixture;
    var cards = this.stage.querySelectorAll('.qz-card');
    for (var i = 0; i < cards.length; i++) cards[i].classList.toggle('is-selected', cards[i] === btn);
    clearTimeout(this.advanceTimer);
    this.advanceTimer = setTimeout(function () { self.go(self.state.step + 1); }, 320);
  };

  Quiz.prototype.go = function (step) {
    this.state.step = step;
    this.render();
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  };

  Quiz.prototype.goBack = function () {
    if (this.state.step >= STEPS.length && this.state.round > 0) {
      this.state.round--;
      this.state.liked = false;
      this.go(this.state.step);
    } else if (this.state.step > 0) this.go(this.state.step - 1);
    else this.go(-1);
  };

  Quiz.prototype.restart = function () {
    clearTimeout(this.advanceTimer);
    this.state = { step: -1, answers: {}, round: 0, liked: false };
    this.render();
  };

  // "¿Te convence?" → Sí: se queda con estas. No: siguiente ronda de 3.
  Quiz.prototype.feedback = function (liked) {
    track('quiz_feedback', { respuesta: liked ? 'si' : 'no', ronda: (this.state.round || 0) + 1 });
    if (liked) {
      this.state.liked = true;
      this.render();
      var box = this.stage.querySelector('.qz-feedback');
      if (box) try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    } else {
      this.state.round = (this.state.round || 0) + 1;
      this.state.liked = false;
      this.go(this.state.step);
    }
  };

  /* Render */

  Quiz.prototype.render = function () {
    var s = this.state.step;
    var total = STEPS.length;
    this.root.setAttribute('data-step', s < 0 ? 'intro' : s >= total ? 'results' : STEPS[s]);
    this.bar.firstChild.style.width = (s < 0 ? 0 : s >= total ? 100 : Math.round(((s + 0.5) / total) * 100)) + '%';
    this.back.hidden = s < 0;
    this.restartBtn.hidden = s < 0;
    this.counter.textContent = s < 0 ? '' : s >= total ? 'Tu recomendación' : ('0' + (s + 1)) + ' / 0' + total;

    var view;
    if (s < 0) view = this.viewIntro();
    else if (s === 0) view = this.viewRooms();
    else if (s === 1) view = this.viewFixtures();
    else if (s === 2) view = this.viewMoods();
    else if (s === 3) view = this.viewBudgets();
    else view = this.viewResults();

    view.classList.add('qz-view');
    this.stage.innerHTML = '';
    this.stage.appendChild(view);
    var title = view.querySelector('h1, h2');
    if (title && s >= 0) { title.setAttribute('tabindex', '-1'); try { title.focus({ preventScroll: true }); } catch (e) {} }
  };

  Quiz.prototype.question = function (eyebrow, title, sub) {
    var wrap = h('section', { class: 'qz-q' });
    wrap.appendChild(h('div', { class: 'qz-q-head' },
      '<p class="qz-eyebrow">' + esc(eyebrow) + '</p>' +
      '<h1 class="qz-title">' + title + '</h1>' +
      (sub ? '<p class="qz-sub">' + esc(sub) + '</p>' : '')));
    var grid = h('div', { class: 'qz-grid' });
    wrap.appendChild(grid);
    return { el: wrap, grid: grid };
  };

  Quiz.prototype.card = function (key, value, inner, extraClass, i) {
    var self = this;
    var selected = this.state.answers[key] === value;
    var btn = h('button', {
      type: 'button',
      class: 'qz-card ' + (extraClass || '') + (selected ? ' is-selected' : ''),
      style: '--i:' + (i || 0),
      'aria-pressed': selected ? 'true' : 'false'
    }, inner);
    btn.addEventListener('click', function () { self.select(key, value, btn); });
    return btn;
  };

  Quiz.prototype.viewIntro = function () {
    var self = this;
    var c = this.cfg;
    var el = h('section', { class: 'qz-intro' });
    if (c.introImage) el.appendChild(h('div', { class: 'qz-intro-media', 'aria-hidden': 'true' }, '<img src="' + esc(c.introImage) + '" alt="">'));
    var body = h('div', { class: 'qz-intro-body' },
      '<p class="qz-eyebrow">' + esc(c.introEyebrow || 'Asesor de iluminación · iLumileds') + '</p>' +
      '<h1 class="qz-intro-title">' + (c.introTitle || 'Encuentra la luz <em>ideal</em> para tu espacio') + '</h1>' +
      '<p class="qz-intro-text">' + esc(c.introText || 'Responde 4 preguntas y te recomendamos las piezas que mejor encajan.') + '</p>');
    var start = h('button', { type: 'button', class: 'qz-btn qz-btn-gold qz-btn-lg', onclick: function () { self.go(0); } }, esc(c.introButton || 'Empezar') + ARROW_R);
    body.appendChild(start);
    body.appendChild(h('ul', { class: 'qz-intro-facts' }, '<li>4 preguntas</li><li>1 minuto</li><li>Catálogo real iLumileds</li>'));
    el.appendChild(body);
    return el;
  };

  Quiz.prototype.viewRooms = function () {
    var q = this.question('Paso 1 · Espacio', '¿Qué quieres <em>iluminar</em>?', 'Elige el espacio principal.');
    var imgs = this.cfg.roomImages || {};
    var self = this;
    E.ROOMS.forEach(function (r, i) {
      var media = imgs[r.id]
        ? '<span class="qz-card-photo"><img src="' + esc(imgs[r.id]) + '" alt="" loading="lazy"></span>'
        : '<span class="qz-card-icon"><svg viewBox="0 0 48 48" aria-hidden="true">' + ICONS[r.icon] + '</svg></span>';
      q.grid.appendChild(self.card('room', r.id, media + '<span class="qz-card-label">' + esc(r.label) + '</span>', imgs[r.id] ? 'qz-card--photo' : 'qz-card--icon', i));
    });
    q.grid.classList.add('qz-grid--rooms');
    return q.el;
  };

  Quiz.prototype.viewFixtures = function () {
    var room = E.find(E.ROOMS, this.state.answers.room) || E.ROOMS[0];
    var q = this.question('Paso 2 · ' + room.label, '¿Qué tipo de <em>luz</em> te imaginas?', 'Estas son las opciones que mejor funcionan en ' + room.label.toLowerCase() + '.');
    var self = this;
    var used = {};
    room.fixtures.forEach(function (id, i) {
      var fx = E.FIXTURES[id];
      var img = self.catalog ? E.fixtureImage(self.catalog, id, room.id, used) : null;
      if (img) used[img] = true;
      var media = img
        ? '<span class="qz-card-product"><img src="' + esc(img) + '" alt="" loading="lazy"></span>'
        : '<span class="qz-card-product is-loading" aria-hidden="true"></span>';
      q.grid.appendChild(self.card('fixture', id, media + '<span class="qz-card-label">' + esc(fx.label) + '</span>', 'qz-card--product', i));
    });
    q.grid.classList.add('qz-grid--fixtures');
    return q.el;
  };

  Quiz.prototype.viewMoods = function () {
    var q = this.question('Paso 3 · Ambiente', '¿Qué <em>ambiente</em> quieres crear?', 'El tono de la luz cambia por completo cómo se siente un espacio.');
    var self = this;
    E.MOODS.forEach(function (m, i) {
      var glow = m.glow === 'conic'
        ? 'background: conic-gradient(from 90deg, #ff9d5c, #ffe08a, #d8ecff, #b7a4ff, #ff8fb1, #ff9d5c)'
        : 'background: radial-gradient(circle at 50% 50%, #fff 0%, ' + m.glow + ' 38%, transparent 72%)';
      q.grid.appendChild(self.card('mood', m.id,
        '<span class="qz-glow" aria-hidden="true"><span style="' + glow + '"></span></span>' +
        '<span class="qz-card-label">' + esc(m.label) + '</span><span class="qz-card-hint">' + esc(m.hint) + '</span>', 'qz-card--mood', i));
    });
    q.grid.classList.add('qz-grid--moods');
    return q.el;
  };

  Quiz.prototype.viewBudgets = function () {
    var q = this.question('Paso 4 · Presupuesto', '¿Cuánto quieres <em>invertir</em>?', 'Aproximado, por pieza. Lo usamos para ordenar las sugerencias.');
    var self = this;
    E.BUDGETS.forEach(function (b, i) {
      q.grid.appendChild(self.card('budget', b.id,
        '<span class="qz-card-big">' + esc(b.label) + '</span><span class="qz-card-hint">' + esc(b.hint) + '</span>', 'qz-card--text', i));
    });
    q.grid.classList.add('qz-grid--budget');
    return q.el;
  };

  Quiz.prototype.viewResults = function () {
    var self = this;
    var a = this.state.answers;
    var el = h('section', { class: 'qz-results' });

    if (!this.catalog) {
      el.appendChild(h('div', { class: 'qz-loading' }, '<span class="qz-spinner" aria-hidden="true"></span><p>Buscando las mejores piezas para ti…</p>'));
      return el;
    }

    var room = E.find(E.ROOMS, a.room), fx = E.FIXTURES[a.fixture], mood = E.find(E.MOODS, a.mood), budget = E.find(E.BUDGETS, a.budget);
    var key = JSON.stringify(a);
    if (this.allPicksKey !== key) { this.allPicks = E.recommendAll(this.catalog, a); this.allPicksKey = key; }
    var round = this.state.round || 0;
    var picks = this.allPicks.slice(round * 3, round * 3 + 3);
    var hasMore = this.allPicks.length > (round + 1) * 3;
    this.lastPicks = picks;

    var chips = [room && room.label, fx && fx.label, mood && mood.label, budget && budget.label].filter(Boolean)
      .map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
    el.appendChild(h('div', { class: 'qz-q-head' },
      '<p class="qz-eyebrow">Tu recomendación' + (round ? ' · Opciones ' + (round * 3 + 1) + '–' + (round * 3 + picks.length) : '') + '</p>' +
      (round ? '<h1 class="qz-title">Probemos con <em>otras opciones</em></h1>' : '<h1 class="qz-title">Elegimos esto <em>para ti</em></h1>') +
      '<ul class="qz-chips">' + chips + '</ul>'));

    if (!picks.length) {
      el.appendChild(h('p', { class: 'qz-sub' }, this.loadError
        ? 'No pudimos cargar el catálogo en este momento. Escríbenos por WhatsApp y un asesor te ayuda.'
        : 'No encontramos piezas para esta combinación. Prueba con otro tipo de luz o escríbenos por WhatsApp.'));
    }

    var grid = h('div', { class: 'qz-products' });
    picks.forEach(function (p, i) {
      var why = [fx && fx.label];
      if (mood && hasMood(p, mood)) why.push('Luz ' + mood.label.split(' ')[0].toLowerCase());
      if (budget && budget.id !== 'any' && p.price >= budget.min && p.price < budget.max) why.push('En tu presupuesto');
      var card = h('article', { class: 'qz-product', style: '--i:' + i });
      card.appendChild(h('a', { class: 'qz-product-media', href: p.url, 'aria-hidden': 'true', tabindex: '-1' },
        (i === 0 && !round ? '<span class="qz-badge">Mejor opción</span>' : '') +
        '<img src="' + esc(p.image) + '" alt="" loading="lazy">'));
      var body = h('div', { class: 'qz-product-body' },
        '<p class="qz-product-why">' + why.filter(Boolean).map(esc).join(' · ') + '</p>' +
        '<h2 class="qz-product-title"><a href="' + esc(p.url) + '">' + esc(shortTitle(p.title)) + '</a></h2>' +
        '<p class="qz-product-price">' + (p.variants > 1 ? '<small>Desde</small> ' : '') + esc(self.money.format(p.price)) + ' <small>MXN</small></p>');
      var actions = h('div', { class: 'qz-product-actions' });
      if (p.variants === 1 && p.variant_id) {
        actions.appendChild(h('button', { type: 'button', class: 'qz-btn qz-btn-gold', onclick: function (e) { self.addToCart(p, e.currentTarget); } }, 'Agregar al carrito'));
      } else {
        actions.appendChild(h('a', { class: 'qz-btn qz-btn-gold', href: p.url }, 'Elegir opción'));
      }
      actions.appendChild(h('a', { class: 'qz-btn qz-btn-ghost', href: p.url }, 'Ver producto'));
      body.appendChild(actions);
      card.appendChild(body);
      grid.appendChild(card);
    });
    el.appendChild(grid);

    if (picks.length) el.appendChild(this.viewFeedback(hasMore));

    var foot = h('div', { class: 'qz-results-foot' });
    if (this.cfg.whatsapp) {
      foot.appendChild(h('a', { class: 'qz-btn qz-btn-wa qz-btn-lg', href: this.whatsappUrl(picks), target: '_blank', rel: 'noopener noreferrer' }, WA + 'Enviar mi recomendación por WhatsApp'));
    }
    foot.appendChild(h('button', { type: 'button', class: 'qz-btn qz-btn-ghost qz-btn-lg', onclick: function () { self.restart(); } }, RESTART + 'Volver a empezar'));
    el.appendChild(foot);
    return el;
  };

  Quiz.prototype.viewFeedback = function (hasMore) {
    var self = this;
    var box = h('div', { class: 'qz-feedback' + (this.state.liked ? ' is-liked' : '') });
    if (this.state.liked) {
      box.innerHTML = '<p class="qz-feedback-title">¡Excelente elección!</p>' +
        '<p class="qz-feedback-text">Agrégala al carrito o envíanos tu selección por WhatsApp: un asesor te ayuda con cantidades, instalación y tu descuento.</p>';
      return box;
    }
    box.appendChild(h('p', { class: 'qz-feedback-title' }, '¿Te convence alguna de estas opciones?'));
    if (!hasMore) {
      box.appendChild(h('p', { class: 'qz-feedback-text' }, 'Estas son las últimas sugerencias para esta combinación. Si ninguna te convence, prueba otro tipo de luz o habla con un asesor.'));
    }
    var actions = h('div', { class: 'qz-feedback-actions' });
    actions.appendChild(h('button', { type: 'button', class: 'qz-btn qz-btn-gold qz-btn-lg', onclick: function () { self.feedback(true); } }, 'Sí, me gusta'));
    if (hasMore) {
      actions.appendChild(h('button', { type: 'button', class: 'qz-btn qz-btn-ghost qz-btn-lg', onclick: function () { self.feedback(false); } }, 'No, muéstrame otras' + ARROW_R));
    } else {
      actions.appendChild(h('button', { type: 'button', class: 'qz-btn qz-btn-ghost qz-btn-lg', onclick: function () { self.state.round = 0; self.state.liked = false; self.go(1); } }, 'Probar otro tipo de luz'));
    }
    box.appendChild(actions);
    return box;
  };

  function track(event, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data)); } catch (e) {}
  }

  function hasMood(p, mood) {
    var t = p._text;
    for (var i = 0; i < mood.any.length; i++) if (t.indexOf(E.norm(mood.any[i])) !== -1) return true;
    return false;
  }

  Quiz.prototype.whatsappUrl = function (picks) {
    var a = this.state.answers;
    var room = E.find(E.ROOMS, a.room), fx = E.FIXTURES[a.fixture], mood = E.find(E.MOODS, a.mood), budget = E.find(E.BUDGETS, a.budget);
    var origin = window.location.origin;
    var lines = [this.cfg.whatsappIntro || 'Hola, hice el quiz de iluminación y me interesan estas piezas:', ''];
    lines.push('Espacio: ' + (room ? room.label : ''));
    lines.push('Tipo de luz: ' + (fx ? fx.label : ''));
    lines.push('Ambiente: ' + (mood ? mood.label : ''));
    lines.push('Presupuesto: ' + (budget ? budget.label : ''));
    lines.push('');
    var self = this;
    picks.forEach(function (p, i) {
      lines.push((i + 1) + '. ' + shortTitle(p.title) + ' — ' + self.money.format(p.price));
      lines.push(origin + p.url);
    });
    var phone = String(this.cfg.whatsapp).replace(/\D/g, '');
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(lines.join('\n'));
  };

  Quiz.prototype.addToCart = function (p, btn) {
    var self = this;
    if (btn.disabled) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Agregando…';
    fetch((this.cfg.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: p.variant_id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
    }).then(function () {
      btn.textContent = 'Agregado ✓';
      btn.classList.add('is-done');
      self.showToast('Agregado al carrito · <a href="' + (self.cfg.root || '/') + 'cart">Ir al carrito</a>');
      self.refreshCart();
      setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-done'); }, 2500);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = label;
      self.showToast(esc(err.message || 'No se pudo agregar. Intenta de nuevo.'));
    });
  };

  Quiz.prototype.refreshCart = function () {
    var self = this;
    fetch((this.cfg.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        self.cartLink.hidden = !c.item_count;
        self.cartLink.textContent = 'Carrito · ' + c.item_count;
      }).catch(function () {});
  };

  Quiz.prototype.showToast = function (html) {
    var t = this.toast;
    t.innerHTML = html;
    t.hidden = false;
    t.classList.remove('is-in');
    void t.offsetWidth;
    t.classList.add('is-in');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.hidden = true; }, 300); }, 4000);
  };

  function boot() {
    var roots = document.querySelectorAll('[data-qz-root]:not(.qz-ready)');
    for (var i = 0; i < roots.length; i++) {
      var q = new Quiz(roots[i]);
      q.refreshCart();
      window.MatelecQuiz = q;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
